import { MaintenanceForwardingCheckinEntryKlass } from "./forwardings/checkinEntries/checkinEntry.type";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "./forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";

export enum MaintenanceForwardingsDirectiveFromSteps {
  DirectiveComplexity = 'DIRECTIVE_COMPLEXITY',
  DirectiveDiagnostic = 'DIRECTIVE_DIAGNOSTIC',
  EstablishmentChoiceEntry = 'establishment_choice_entry',
  CheckinEntry = 'checkin_entry',
}

export type MaintenanceForwardingsRequiredDirectiveStepsData = {
  [MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity]?: null;
  [MaintenanceForwardingsDirectiveFromSteps.DirectiveDiagnostic]?: null;
  [MaintenanceForwardingsDirectiveFromSteps.EstablishmentChoiceEntry]?: MaintenanceForwardingEstablishmentChoiceEntryKlass[];
  [MaintenanceForwardingsDirectiveFromSteps.CheckinEntry]?: MaintenanceForwardingCheckinEntryKlass[];
};

export type MaintenanceForwardingsShowDirectiveDetailsData = {
  name: string;
  description: string;
  can_create: boolean;
  required_directive_steps: MaintenanceForwardingsRequiredDirectiveStepsData | null;
}

export type MaintenanceForwardingsShowDirectiveDetailsResponse = {
  data: {
    data: MaintenanceForwardingsShowDirectiveDetailsData
  }
}

export type MaintenanceForwardingsDirectiveFormProps = {
  directiveDetails: MaintenanceForwardingsShowDirectiveDetailsData;
}

